import { LatestAccomplishmentType } from '@/models/geek-profile';
import Vue from 'vue';

export const latestAccomplishmentMixin = Vue.extend({
    methods: {
      dispatchActionForLatestAccomplishment(this: any) {
        if (this.latestGained.accomplishmentType === LatestAccomplishmentType.None) {
          return this.$router.push({name: 'reward-geek'});
        }

        const actions = {
          [LatestAccomplishmentType.Activity]: () => this.goToActivities(),
          [LatestAccomplishmentType.Achievement]: () => this.goToAchievements(),
          [LatestAccomplishmentType.Badge]: () => this.goToBadges(),
        } as { [key: string]: () => void };

        actions[this.latestGained.accomplishmentType]();
      },
      refreshLatestAccomplishment(this: any) {
        switch (this.latestGained.accomplishmentType) {
          case LatestAccomplishmentType.Achievement:
            this.latestAccomplishment = {
              imageUrl: this.latestGained.latestAchievement.imageUrl,
              text: this.latestGained.latestAchievement.type,
            };
            break;
          case LatestAccomplishmentType.Activity:
            this.latestAccomplishment = {
              imageUrl: `${this.publicPath}icons/activities/`
                + `${this.latestGained.latestActivity.type}-md.png`,
              text: this.$t(`activity.types.${this.latestGained.latestActivity.type}.name`) as string,
            };
            break;
          case LatestAccomplishmentType.Badge:
            this.latestAccomplishment = {
              imageUrl: `${this.publicPath}icons/badges/` +
                `${this.latestGained.latestBadge.color}-${this.latestGained.latestBadge.type}-md.png`,
              text: this.$t(`badge.types.${this.latestGained.latestBadge.type}.name`) as string,
            };
            break;
          default:
            break;
        }
      },
    },
});


